<template>
  <div class="columns is-mobile is-gapless layer-catalog">
    <div class="column is-narrow is-relative">
      <input
        type="checkbox"
        class="is-checkradio is-link is-small"
        :class="{ 'has-background-color': catalog.visible }"
        v-model="catalog.visible"
        :id="id"
      />
      <label class="label-checkbox" :for="id"></label>
    </div>
    <div class="column">
      <label class="layer-name" :for="id">{{ catalog.displayName }} </label>
    </div>
    <div class="column is-narrow">
      <slider-picker
        :min="0"
        :max="100"
        :step="1"
        v-model="catalog.opacityPercent"
        title="непрозрачность"
        v-if="catalog.visible || catalog.infoSetKeys"
      ></slider-picker>
    </div>
  </div>
</template>
<script>
import SliderPicker from '../../common/SliderPicker';
export default {
  components: { SliderPicker },
  props: {
    catalog: Object,
  },
  computed: {
    id() {
      return `cat${this.catalog.id}`;
    },
  },
  methods: {
    setChecked(value) {
      this.$emit('catalog-checked', value ? 1 : -1);
    },
    setPartChecked(value) {
      this.$emit('catalog-partchecked', value ? 1 : -1);
    },
  },
  created() {
    //if (this.catalog.visible) this.setChecked(true);
  },
  watch: {
    'catalog.visible'(val) {
      if (val) this.catalog.infoSetKeys = null;
      this.setChecked(val);
    },
    'catalog.infoSetKeys'(val) {
      this.setPartChecked(val);
    },
  },
};
</script>
<style>
.layer-catalog {
  padding-left: 24px;
}

.label-checkbox {
  padding-left: 10px !important;
}

.layer-name {
  cursor: pointer;
}
</style>
